<template>
    <textarea :name="name"></textarea>
</template>

<script>
  export default {
    name: 'summernote',
    props: {
      model: {
        required: true,
      },
      name: {
        type: String,
        required: true,
      },
      height: {
        type: Number,
        default: 200
      }
    },

    beforeCreate() {
      // let link  = document.createElement('link');
      // link.rel  = 'stylesheet';
      // link.type = 'text/css';
      // link.href = '/assets/css/summernote.css';
      // link.media = 'all';
      // document.head.appendChild(script);
      //
      // let script = document.createElement('script');
      // script.src = '/assets/js/summernote.js';
      // script.onload = function () {
      //   console.log('Script loaded')
      // };
      // document.head.appendChild(script);

    },

    mounted() {
      let config = {
        height: this.height
      };

      let vm = this;

      config.callbacks = {

        onInit: function () {
          $(vm.$el).summernote("code", vm.model);
        },

        onChange: function () {
          vm.$emit('change', $(vm.$el).summernote('code'));
        },

        onBlur: function () {
          vm.$emit('change', $(vm.$el).summernote('code'));
        }
      };
      $(this.$el).summernote(config);
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Summernote.vue?54083aa2